import { Text, View, useColorScheme } from 'react-native';
import React, { Suspense, memo, lazy } from 'react';
import DefaultScreen from '@components/Global/DefaultScreenView';
import Button from '@components/UI/Button/Button';
import { useNavigation } from '@react-navigation/native';
import DropDownView from '@components/Global/DropDownView';
import MenuIconCard from '@components/Global/MenuIconCard';
import { useTranslation } from 'react-i18next';
import { XStack } from 'tamagui';



const AnimatedLottieView = lazy(() => import('@utils/lottieAnimation'));

const LazyLottieView = (props) => (
  <Suspense fallback={<View />}>
    <AnimatedLottieView {...props} />
  </Suspense>
);

const CalendarMenu = ({ navigation }) => {
  const { t } = useTranslation();

  return (
    <DefaultScreen backButton>
      <XStack gap={20} columnGap={20} flexWrap="wrap" style={{ paddingTop: "15%", paddingVertical: 25, gap: 5, paddingBottom: 150, alignSelf: 'stretch', flexDirection: 'row', flexWrap: 'wrap' }}>
        <MenuIconCard pressFunction={() => navigation.navigate('Meetings')} subtitle={`${t('CalendarMeetingsSub')}`} cardTitle={`${t('Meetings')}`}>
          <LazyLottieView source={require('@assets/animations/magnifExample.json')} loop={false} style={{ width: '100%', height: 70, alignSelf: 'center', justifyContent: 'center' }} autoPlay />
        </MenuIconCard>
        <MenuIconCard pressFunction={() => navigation.navigate('Reminders')} subtitle={`${t('CalendarRemindersSub')}`} cardTitle={`${t('Reminders')}`}>
          <LazyLottieView source={require('@assets/animations/star.json')} loop={false} style={{ width: '80%', height: 70, justifyContent: 'center', alignSelf: 'center' }} autoPlay />
        </MenuIconCard>
        <MenuIconCard pressFunction={() => navigation.navigate('Breakdown')} subtitle="View your week at a glance" cardTitle="Breakdown">
          <LazyLottieView source={require('@assets/animations/star.json')} loop={false} style={{ width: '80%', height: 70, justifyContent: 'center', alignSelf: 'center' }} autoPlay />
        </MenuIconCard>
      </XStack>
    </DefaultScreen >
  )
}
export default memo(CalendarMenu);